import { CLEAR_PAGE } from '../base/types';
import { FETCH_SINGLE_SEO_PAGE } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: {}
};

const singleSeoPageReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_SINGLE_SEO_PAGE}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_SINGLE_SEO_PAGE}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_SINGLE_SEO_PAGE}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case CLEAR_PAGE:
      return payload === 'singleSeoPage' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default singleSeoPageReducer;
